export default class Actor extends THREE.Group {
	/**
     * @param {THREE.Object3D} mesh The object that is displayed as the Actor
     * @class
	 */
	constructor(mesh) {
		super();

		/**
		 * @type {tile}
		 */
		this.tile = null;

		/**
		 * @type {Object}
		 */
		this._type = Actor.WALL;

		/**
		 * @type {Object}
		 */
		this._specialType = Actor.SPECIAL_NONE;

		/**
		 * @type {THREE.Mesh}
		 */
		this.mesh = mesh;

		/**
		 * @type {Object[]}
		 */
		this.links = [];

		/**
		 * @type {Boolean}
		 */
		this._linked = false;

		/**
		 * @type {THREE.Box3}
		 */
		this.bb = null;

		/**
		 * @type {THREE.Object3D[]}
		 */
		this._updatables = [];

		this.startParameters = {
			position  : new THREE.Vector3(),
			tileWater : null
		};

		this.tweens = new P3.utils.TWEEN.Group();

		this.add(mesh);
		this.init();
	}

	init() {

	}

	destroy() {
		this.mesh.geometry.dispose();
		this.mesh.material.dispose();
	}

	reset() {
		this.position.copy(this.startParameters.position);
		// this.tile.position3D.copy(this.startParameters.position);
		this.tile.isUnderwater = this.startParameters.tileWater === null ? this.tile.isUnderwater : this.startParameters.tileWater;
		this.updateMatrix();
		this.updateMatrixWorld();
	}

	update() {
		for (const item of this._updatables) {
			item.update();
		}

		this.tweens.update(P3.Ticker.dt);
	}

	/**
	 * Gets the boudning size of the object in world-space. Calculates the bounding box first and then returns an object with dimensions.
	 * @returns {Object}	An object with `width`, `height`, and `depth` parameters.
	 * @private
	 */
	_getSize() {
		this.mesh.updateMatrixWorld(true);

		const bb = new THREE.Box3().setFromObject(this.mesh);
		const width = bb.max.x - bb.min.x;
		const height = bb.max.y - bb.min.y;
		const depth = bb.max.z - bb.min.z;

		return {width: width, height: height, depth: depth};
	}

	activate() {
		if (this.tile.isUnderwater) {
			new P3.utils.TWEEN.Tween(this.position, this.tweens)
				.to({
					y: 0
				}, 500)
				.easing(P3.utils.Easing.Back2.Out)
				.onUpdate(() => {
					this.updateMatrix();
					this.updateMatrixWorld();
				})
				.start();

			this.startParameters.tileWater = this.tile.isUnderwater;
			this.tile.isUnderwater = false;
		}
	}

	/**
	 * Links two objects together. Either `o1` or `o2` should be a reference to this object. A link should be established for both objects simultaenously.
	 * @param {Actor} o1 The TO link
	 * @param {Actor} o2 The FROM link.
	 */
	addLink(sender, receiver) {
		this.links.push({sender: sender, receiver: receiver});
		this._linked = true;
	}

	update() {
		this.tweens.update();
	}

	set type(v) {
		this._type = v;
	}

	get type() {
		return this._type;
	}

	set specialType(v) {
		this._specialType = v;
	}

	get specialType() {
		return this._specialType;
	}

	get linked() {
		return this._linked;
	}

	set linked(v) {
		this._linked = v;
	}

	get updatables() {
		return this._updatables;
	}

	set updatables(v) {
		this._updatables = v;
	}
}

Actor.WALL = 'wall';
Actor.TILE = 'tile';
Actor.UNDERWATER_TILE = 'tile_underwater';
Actor.OBJECT = 'object';
Actor.PLAYER = 'player';

/* Special Types*/
Actor.SPECIAL_NONE = 0;
Actor.SPECIAL_CONVEYOR = 1;
